require('dotenv').config();

export const config = {
  REACT_APP_API_GATEWAY: process.env.REACT_APP_API_GATEWAY,
  MODE: process.env.REACT_APP_MODE,
  VERSION: process.env.REACT_APP_RELEASE_VERSION
};
